import axios from 'axios'

import {
	AUTH_ERROR,
	TASK_SET_CURRENT,
	TASK_LOADING_DATA,
	COMMENT_LIKED
} from './types'

import { API_URL } from '../api'
import { cookies } from './index'

import { isArray } from 'lodash'
import copy from 'fast-copy'
import { getDateString } from 'utils'

import moment from 'moment'

// Update after auth is refactored
import { errorHandler } from './actions'

// TODO: maybe merge this with updateTask?
export function createTask(name, milestone_id, callback = null) {
	return dispatch => {
		axios.post(API_URL + '/tasks/create', { name, milestone_id })
			.then(response => {
				if (callback) {
					callback(response.data)
				}

				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'task',
				})
			})
			.catch(error => {
				console.log(error)
				errorHandler(dispatch, error.response, AUTH_ERROR)
			})
	}
}

export const updateTask = (taskData, callback) => {
	return dispatch => {
		if (isArray(taskData)) {
			taskData.forEach(task => {
				axios.post(API_URL + '/tasks/update', { taskData: task })
			})
		} else {
			axios.post(API_URL + '/tasks/update', { taskData })
		}

		const dateString = getDateString()
		const clonedTaskData = copy(taskData)

		const _taskArray = isArray(clonedTaskData) ? clonedTaskData : [clonedTaskData]

		_taskArray.forEach(task => {
			task.updated_at = dateString
		})

		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: _taskArray,
			entityType: 'task',
			isArray: true,
			overwriteUsers: true
		})

		if (callback && typeof callback === 'function') {
			setTimeout(() => {
				callback()
			}, 100)
		}
	}
}

export function updateTaskOrder(milestoneData, isQuickTasks) {
	return dispatch => {
		axios.post(API_URL + '/tasks/updateOrder', {
			milestoneData,
			isQuickTasks
		})

		const dateString = getDateString()
		const clonedMilestoneData = copy(milestoneData)

		clonedMilestoneData.forEach(milestone => {
			milestone.tasks.forEach(task => {
				task.updated_at = dateString
			})
		})

		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: clonedMilestoneData,
			entityType: 'milestone',
			isArray: true,
			overwriteTasks: true
		});
	}
}

export function getTaskData(id, callback = null) {
	return dispatch => {
		dispatch({
			type: TASK_SET_CURRENT,
			payload: id,
		})

		dispatch({
			type: TASK_LOADING_DATA,
		})

		axios.get(API_URL + '/tasks?id=' + id).then(response => {
			dispatch({
				type: 'SEE_TASK_NOTIFICATIONS',
				payload: response.data['task'].id
			})

			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: response.data['task'],
				entityType: 'task',
			})

			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: response.data['user'],
				entityType: 'user',
			})

			if (callback) {
				callback()
			}
		})
			.catch(error => {
				if (callback) {
					callback(true)
				}
			})
	}
}

export function closeTask() {
	return dispatch => {
		dispatch({
			type: TASK_SET_CURRENT,
			payload: null,
		})
	}
}

export function postComment(comment, mentionIds, user, task, repliedComment = null) {
	return dispatch => {
		axios.post(API_URL + '/tasks/comment', { comment, user, task, mentionIds, repliedComment })
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'comment',
				})
			}).catch(error => {
				console.log('error updating order!');
				console.log(error);
			});
	}
}

export function updateComment(message) {
	return dispatch => {
		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: message,
			entityType: 'comment',
		})

		axios.post(API_URL + '/tasks/comment/update', { comment: message }).then(response => {

		})
	}
}

export function likeComment(comment, user) {
	return dispatch => {
		axios.post(API_URL + '/tasks/comment/like', { comment, user })

		dispatch({
			type: COMMENT_LIKED,
			payload: {
				commentId: comment.id,
				userId: user.id
			},
		});
	}
}

export function restoreTasks(tasks, milestone) {
	return dispatch => {
		let clonedMilestone = copy(milestone)

		clonedMilestone.deleted_at = null
		clonedMilestone.tasks = []

		tasks.forEach(task => {
			dispatch({
				type: 'ENTITY_DELETED',
				entityType: 'task',
				payload: task,
			})

			let clonedTask = copy(task)
			clonedTask.deleted_at = null

			clonedMilestone.tasks.push(clonedTask)

			const archivedTaskIdIndex = clonedMilestone.archivedTasks.findIndex(taskId => {
				return taskId == clonedTask.id
			})

			if (archivedTaskIdIndex > -1) {
				clonedMilestone.archivedTasks.splice(archivedTaskIdIndex, 1)
			}
		})

		axios.post(API_URL + '/tasks/restore', { tasks }).catch(error => {
			console.log(error)
		})

		// we don't remove milestone from archive. Just hides if it's empty.
		// we always return the milestone with the task.

		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: clonedMilestone,
			entityType: 'milestone',
		})
	}
}

export function toggleTimer(task, runningSessionId = null) {
	return dispatch => {
		// If there's an existing session, don't wait for the API response
		if (runningSessionId) {
			const clonedSession = {
				id: runningSessionId,
				stopped_at: moment().format('YYYY-MM-DD HH:mm:ss')
			}

			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: clonedSession,
				entityType: 'session',
			})
		}

		axios.post(API_URL + '/tasks/toggleTimer', { task })
			.then(response => {
				const sessions = response.data

				if (sessions) {
					dispatch({
						type: 'ENTITY_ADDED_OR_UPDATED',
						payload: sessions,
						entityType: 'session',
						isArray: true
					})

					dispatch({
						type: 'ENTITY_ADDED_OR_UPDATED',
						payload: {
							id: sessions[0].user_id,
							showing_timer: 1
						},
						entityType: 'user'
					})
				}
			}).catch(error => {
				console.log(error)
			})
	}
}

export function hideTimer(userId) {
	return dispatch => {
		axios.post(API_URL + '/tasks/hideTimer')

		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: {
				id: userId,
				showing_timer: 0
			},
			entityType: 'user',
		})
	}
}

export const getTrackedTime = (task, callback) => {
	return dispatch => {
		axios.get(API_URL + '/tasks/getTracked/' + task.id)
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'task',
				})

				callback()
			})
			.catch(error => {
				console.log(error)
			})
	}

}

export const dismissTask = (data, task, user) => {
	const clonedTaskDismissals = task.dismissals ? task.dismissals : {}

	let unitString

	switch (data.unitId) {
		case 1:
			unitString = 'days'
			break
		case 2:
			unitString = 'weeks'
			break
		case 3:
			unitString = 'months'
			break
	}

	const dismissedUntilString = moment().add(data.unit, unitString).startOf('day').format('Y-MM-DD')

	clonedTaskDismissals[user.id] = dismissedUntilString

	return dispatch => {
		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: {
				...task,
				dismissals: clonedTaskDismissals
			},
			entityType: 'task',
		})

		axios.post(API_URL + '/tasks/dismiss/' + task.id, { dismissedUntilString })
	}
}

// Checklist actions are retained to avoid breaking imports in todos.jsx/todo.jsx,
// but the API routes have been removed — these will no-op if called.
export const createChecklistItem = (value, task) => () => {}
export const updateChecklistItem = item => () => {}
export const updateChecklistItemOrder = items => () => {}

export const setTaskRecurrence = task => {
	return dispatch => {
		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: task,
			entityType: 'task',
		})

		axios.post(API_URL + '/tasks/setRecurrence/' + task.id, { task })
			.catch(error => {
				console.log(error)
			})
	}
}

export const removeCommentsFromTask = (task, commentIds) => {
	return dispatch => {
		commentIds.forEach(commentId => {
			dispatch({
				type: 'ENTITY_DELETED',
				payload: {
					id: commentId,
					task_id: task.id
				},
				entityType: 'comment',
			})

		})
	}
}

export const addQuickTask = task => {
	return dispatch => {
		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: {
				...task,
				is_quick_task: !task.is_quick_task
			},
			entityType: 'task',
		})

		axios.post(API_URL + '/tasks/setQuickTask/' + task.id)
			.catch(error => {
				console.log(error)
			})
	}
}

export const getQuickTasks = (accountId, callback) => {
	return dispatch => {
		axios.get(API_URL + '/tasks/getQuickTasks/' + accountId)
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data.account,
					entityType: 'account',
				})

				callback(response.data.columns)

				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data.columns,
					entityType: 'column',
					isArray: true,
				})
			}).catch(error => {
				console.log(error)
			})
	}
}

export const searchTasks = (accountId, term, callback) => {
	return dispatch => {
		axios.post(API_URL + '/tasks/search', {
			accountId,
			term
		}).then(response => {
			callback(response.data)
		}).catch(error => {
			console.log(error)
		})
	}
}

export const addManualSession = (taskId, amountInSeconds, date, callback) => {
	return dispatch => {
		axios.post(API_URL + '/tasks/addManualSession', { taskId, amountInSeconds, date })
			.then(response => {
				const session = response.data

				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: session,
					entityType: 'session',
				})

				callback()
			}).catch(error => {
				console.log(error)
				callback()
			})
	}
}